"use client";

import React from "react";
import { ArrowRight, ShieldAlert } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Ul508aMarkingCompliance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="ul-508a-marking-compliance" className="bg-background">
      <div className="bg-secondary py-16 md:py-24 lg:py-32">
        <div ref={ref} className={`container mx-auto px-4 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center gap-3 mb-6">
            <ShieldAlert className="size-8 text-primary" />
            <h2 className="text-3xl md:text-4xl font-bold font-default text-accent">
              How Does Evermark Marking Relate to UL 508A?
            </h2>
          </div>

          <div className="space-y-8 text-lg text-accent/90 font-sans leading-relaxed">
            <p>
              UL 508A, the standard for industrial control panels, includes provisions for how a panel is marked — the equipment nameplate and its electrical ratings, field-wiring and warning markings, and identification of components. Evermark Industrial Solutions produces nameplates and marking designed to align with these conventions when properly specified.
            </p>

            <div className="relative border-l-4 border-primary bg-background/10 pl-6 pr-4 py-6 rounded-r-lg shadow-md">
              <p className="font-medium text-accent">
                Evermark Industrial Solutions produces marking, not panels. Evermark does not build, list, or certify control panels, and producing a nameplate does not make a panel UL 508A listed — the listing comes from the panel builder's own UL 508A program and the certifying body. Whether a panel's marking satisfies UL 508A depends on the panel design, its ratings, the data on the nameplate, and the listing program, so Evermark recommends confirming the marking content and format with the shop's UL program, the engineer of record, or a qualified specialist.
              </p>
            </div>

            <p>
              Arc flash labels are produced from the data in the panel owner's or engineer's arc flash study; Evermark does not perform the study or determine the hazard values.
            </p>
          </div>

          
        </div>
      </div>
    </section>;
}